<template>
        <div class="mb-primary">
            <app-tab :tabs="tabsSuppliers" :active-tab="activeTab" type="horizontal"  :selectedUrl="selectedUrl"/>
        </div>
</template>

<script>

export default {
    props: {
        companyType: {
            type: Number,
            required: false
        }
    },
    data() {
        return {
            icon: 'settings',
            selectedUrl: '',
            tabsSuppliers: [
                {
                    "icon": "send",
                    "name": "customer Info",
                    "component": "customer-add",
                    "permission": "",
                    "disabled": false,

                },
                {
                    "icon": "phone",
                    "name": "Contacts",
                    "component": "customer-contacts",
                    "permission": "",
                    "disabled": true
                },
                {
                    "icon": "send",
                    "name": "Shipping Addresses",
                    "component": "customer-Address",
                    "permission": "",
                    "disabled": true
                },
            ],
            activeTab: 0
        }
    },

    created(){
        // esta llegando el 2 pero no lo usare ahoramismo
    },

}
</script>